<template>
    <div class="newsNew-section" :style="styleObj" v-loading="loading">
        <slot name="module-header"></slot>
        <div class="newsNew-section-content">
            <div class="newsNew-section-content-left" :style="{'width': data.length <= 2 ? '100%' : 'calc(50% - 20px)'}">
                <div class="content-list" v-for=" (item,index) in data.slice(0,leftModuleDataNum)" :key = "index" @click="$emit('go-to-news-detail',item,index,moduleIndex)" @mouseenter="hoverStatus=index" @mouseleave="hoverStatus=-1" :class="{'content-list-hoverStatus' : hoverStatus=== index}">
                    <div class="news-item" :class = "{'readed-active' : item.read === '1'}" @click="handle(index)">
                        <div class="news-item-left" :style="{'width': item.titleImage ? 'calc(100% - 178px)' : '100%'}">

                            <p class="news-item-left-title"> <img v-if="item.topStatus && item.topStatus === '1'" class="topIcon keep-hue" :src="require('@/assets/NewsCenter/topstatus.png')" alt="">
                                <span class="title oneRowEllipsis">{{item.title || '-'}}</span>
                                <img class="new keep-hue"  v-if="item.isNewNews"  :src="require('@/assets/Home/Index/NewsIndex/newNews.png')"></p>
                            </p>

                            <p class="news-item-left-desc threeRowEllipsis" v-if="item.contentDesc">{{item.contentDesc || '-'}}</p>

                            <ListFoot :data="item" :class="item.contentDesc ? 'mt3' : 'mt13'"/>
                        </div>
                        <div v-if="item.titleImage && item.contentDesc" class="news-item-right">
                            <img class="keep-hue" :src="item.titleImage.split(',')[0]" />
                        </div>
                    </div>
                </div>
            </div>
            <div class="newsNew-section-content-right" v-if="data.length > 2" >
                <div class="content-list" v-for=" (item,index) in data.slice(leftModuleDataNum,leftModuleDataNum+4)" :key = "index+'9'" @click="$emit('go-to-news-detail',item,index + 2,moduleIndex)"  @mouseenter="hoverStatus=index+9" @mouseleave="hoverStatus=-1" :class="{'content-list-hoverStatus' : hoverStatus=== index+9}">
                    <SimpleNewsItem :data="item"/>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import SimpleNewsItem from "./simpleNewsItem";
    import ListFoot from "./listFoot";

    export default {
        name: "NewsRowModule",
        data(){
            return {
                hoverStatus: -1
            }
        },
        props: {
            styleObj:{ type:Object, default: ()=> {} },
            data: { type: Array, default: () => []},
          loading:{ type: Boolean, default:false},
          moduleIndex: {type: Number, default:0},
        },
        created() {
        },
      watch:{
        data(){

        }
      },
      computed:{
          leftModuleDataNum(){
            let tt = 0
            for(let i=0;i<this.data.length;i++) {
              if(tt>=4) {
                return i;
                break;
              }
              if(this.data[i].contentDesc) {
                tt += 2
              }else{
                tt+=1
              }

            }

          }
      },
        components: {
            SimpleNewsItem,
            ListFoot,
        },
        methods: {
            handle(index) {
                // 点击设置已读状态
                if(this.data[index].read !== '1') this.$set(this.data[index],'read','1');


            }
        }
    }
</script>

<style scoped lang="scss">
    @import "@/styles/variables.scss";
 .newsNew-section {
     border-radius: 6px;
     box-sizing: border-box;
     background-color: rgba(255,255,255,0.95);
   border-left:3px solid $color-primary;
   overflow: hidden;
     &-content {
         display: flex;
         justify-content: space-between;
       margin-top: 8px;
         .content-list {
           padding-top: 7px;
           padding-bottom: 8px;
             border-bottom: 1px solid #E6E6E6;
             &:nth-last-child(1) {
                 border: none;
             }
             &-hoverStatus {
                 /*box-shadow: 0px 1px 10px 0px rgba(14, 108, 203, 0.1);*/
                 /*background-color: rgba(255, 255, 255, 1);*/
                 /*border: none;*/
                 /*transition: all 0.5s;*/
                 cursor: pointer;

             }
         }
         &-left {
             box-sizing: border-box;
             width: calc(50% - 20px);
             .content-list {
                 padding-left: 30px;
                 padding-right: 20px;
             }
             .news-item {
                 display: flex;
                 width: 100%;
                 box-sizing: border-box;
                 &.readed-active {
                     .news-item-left {
                         .news-item-left-title {
                             color: #666666;
                           &:hover {
                             color: $color-primary;
                             cursor: pointer;
                           }
                         }

                     }

                 }

                 &-left{
                     width: 100%;
                     display: flex;
                     flex-direction: column;
                     box-sizing: border-box;
                     &-title {
                         max-width: 100%;
                         color: #111111;
                         font-weight: bold;
                         font-size: 16px;
                         display: flex;
                       align-items: center;
                         flex-direction: row;
                         img {
                             width: 30px;
                             height: 16px;
                             margin-right: 10px;
                         }
                         .new {
                             width: 30px;
                             height: 16px;
                             margin-left: 10px;
                         }
                         .title {
                             flex:1;
                             line-height: 24px;
                             max-height: 48px;
                         }
                         @media (max-width: 1719px){
                                 font-size: 16px;
                         }
                         &:hover {
                             color: $color-primary;
                             cursor: pointer;
                         }
                     }
                     &-desc {
                         margin-top: 4px;
                         font-size: 14px;
                         font-weight: 400;
                         color: #666666;
                         line-height: 26px;
                         height: 80px;
                     }
                     .blank {
                         flex-grow:1;
                     }

                 }
                 &-right {
                     width: 140px;
                     height: 93px;
                     overflow: hidden;
                     margin-left: 38px;
                     img {
                         width: 100%;
                         height: 100%;
                         border-radius: 6px;
                       object-fit: cover;
                     }

                 }
             }
         }
         &-right {
             width: calc(50% - 20px);
             .content-list {
                 padding-left: 20px;
                 padding-right: 30px;
             }


         }




     }
 }
</style>